import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { LogOut, Sparkles, ShoppingBag } from "lucide-react";

export default function Nav() {
  const { user, logout } = useAuth();
  const { count } = useCart();
  const navigate = useNavigate();
  const loc = useLocation();

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  const link = (to, label, testid) => (
    <Link
      to={to}
      data-testid={testid}
      className={`font-head text-xs uppercase tracking-[0.18em] px-3 py-1.5 transition-colors ${
        loc.pathname === to ? "text-cyan text-glow-cyan" : "text-slate-400 hover:text-cyan"
      }`}
    >
      {label}
    </Link>
  );

  return (
    <header className="sticky top-0 z-50 glass-strong border-b border-cyan/15" data-testid="main-nav">
      <div className="mx-auto max-w-7xl px-5 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
          <div className="w-7 h-7 border-2 border-cyan box-glow-cyan rotate-45 group-hover:rotate-90 transition-transform duration-500" />
          <span className="font-head text-lg font-bold tracking-[0.3em] text-glow-cyan">AETHER</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {link("/pricing", "Tiers", "nav-pricing")}
          {link("/shop", "Store", "nav-shop")}
          {link("/explore", "Explore", "nav-explore")}
          {user && link("/studio", "Studio", "nav-studio")}
          {user && link("/simulation", "Simulation", "nav-simulation")}
          {user && link("/dashboard", "Console", "nav-dashboard")}
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/shop/cart" data-testid="nav-cart" className="relative text-slate-400 hover:text-cyan transition-colors">
            <ShoppingBag className="w-5 h-5" />
            {count > 0 && (
              <span className="absolute -top-2 -right-2 bg-amber text-app font-mono text-[9px] w-4 h-4 flex items-center justify-center rounded-full">
                {count}
              </span>
            )}
          </Link>
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2 font-mono text-[10px] text-amber border border-amber/40 px-2.5 py-1">
                <Sparkles className="w-3 h-3" />
                {user.tier_name?.toUpperCase()}
              </div>
              <button
                onClick={doLogout}
                data-testid="logout-btn"
                className="btn-hud text-xs border border-cyan/40 text-cyan px-3 py-1.5 hover:bg-cyan hover:text-app flex items-center gap-1.5"
              >
                <LogOut className="w-3.5 h-3.5" /> Exit
              </button>
            </>
          ) : (
            <Link
              to="/auth"
              data-testid="nav-login-btn"
              className="btn-hud text-xs border border-cyan/50 text-cyan px-4 py-1.5 hover:bg-cyan hover:text-app box-glow-cyan"
            >
              Initiate Uplink
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
